import isSharedComponent from '../../hoc/isSharedComponent';
export default isSharedComponent;